import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from '@tanstack/react-router';

import { persistOptions, queryClient } from '@/_shared';

import { TooltipProvider } from './_components/ui/tooltip';
import { ThemeProvider } from './_providers';
import { tsRouter } from './router';

function App() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <ThemeProvider defaultTheme="light" storageKey="anna-vite-ui-theme">
        <TooltipProvider>
          <RouterProvider router={tsRouter} defaultPreload="intent" />
        </TooltipProvider>
      </ThemeProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </PersistQueryClientProvider>
  );
}

export default App;
